import { io, Socket } from "socket.io-client";
import { storageKey } from "../configs/config";

class SocketService {
  private socket: Socket | null = null;

  connect(): Socket | null {
    if (this.socket?.connected) return this.socket;

    const accessToken = localStorage.getItem(storageKey.accessToken);
    if (!accessToken) return null;

    this.socket = io(import.meta.env.VITE_BACKEND_API_URL, {
      auth: { token: accessToken },
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    });

    this.socket.on("connect", () => {
      console.log("Global socket connected:", this.socket?.id);
    });

    this.socket.on("disconnect", (reason) => {
      console.log("Global socket disconnected:", reason);
    });

    this.socket.on("connect_error", (error) => {
      console.error("Global socket connection error:", error);
    });

    return this.socket;
  }

  getSocket(): Socket | null {
    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}

const socketService = new SocketService();
export default socketService;
